import HomeContent from './SectionContent'

export type InternalBannerProps = {
  title?: string
  description?: string
  image?: string
}

const InternalBanner = ({ title, description, image }: InternalBannerProps) => {
  return (
    <HomeContent>
      <div
        aria-label="Internal banner"
        className={`flex flex-col gap-2 ${image ? 'py-0' : 'py-4'} sm:flex-row sm:items-center`}
      >
        {image && <img src={image} alt="Resilience Explorer" className="h-[60px]" />}
        {title && <h3 className="text-h3 text-primary font-semibold">{title}</h3>}
        {description && (
          <p className={`${image && 'lg:-ml-12'} text-lg text-foreground`}>{description}</p>
        )}
      </div>
    </HomeContent>
  )
}

export default InternalBanner
